<div class="submit-container">
  <p *ngIf="message === messageType.REQUEST_SUBMISSION" class="submit-success-text">
    {{'submitted.request_submission' | translate}}
  </p>
  <p *ngIf="message === messageType.PASSWORD_CHANGED" class="submit-success-text">
    {{'submitted.password_changed' | translate}}
  </p>
  <p *ngIf="message === messageType.ERROR" class="submit-success-text">
    {{'submitted.error' | translate}}
  </p>
  <p *ngIf="message === messageType.CHANGES_SAVED" class="submit-success-text">
    {{'submitted.new_changes' | translate}}
  </p>
  <p *ngIf="message === messageType.DYNAMIC" class="submit-success-text">{{messageText | translate}}</p>
</div>
